import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClubFooter"] */ "/vercel/path0/src/components/club-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClubHeader"] */ "/vercel/path0/src/components/club-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerStripClient"] */ "/vercel/path0/src/components/partner-strip-client.tsx");
